export default {
  "SettingsPanel": "_SettingsPanel_1vpjj_1",
  "Section": "_Section_1vpjj_25"
};import "ni:sha-256;NSjTMhzeisP8YVAZQyB24yt0TO88Vv_qqa5UuIkpg4M";